export default __webpack_public_path__ + "static/media/vi_upload_your_payslips.1edb1c37.svg";